import Bowser from 'bowser';
import { FirebaseToken, RegisterDeviceOptions, UUID } from '../types';

const browser = Bowser.parse(window.navigator.userAgent);

export interface FirebaseRegisterDeviceOptions {
    firebaseToken: FirebaseToken;
    userId: UUID;
    deviceId: UUID;
}

export const getRegisterDeviceOptionsForFirebase = ({
    firebaseToken,
    userId,
    deviceId,
}: FirebaseRegisterDeviceOptions): RegisterDeviceOptions => {
    return {
        appversion: `${process.env.REACT_APP_VERSION}`,
        description: browser.browser.name ?? '',
        deviceid: deviceId,
        devicemake: browser.os.name ?? '',
        deviceos: browser.os.version ?? '',
        devicetoken: firebaseToken,
        type: 'Desktop',
        userId,
        appname: 'userapp',
    };
};

export interface WebsocketRegisterDeviceOptions {
    userId: UUID;
    deviceId: UUID;
}

export const getRegisterDeviceOptionsForWebsocket = ({
    userId,
    deviceId,
}: WebsocketRegisterDeviceOptions): RegisterDeviceOptions => {
    return {
        appversion: `${process.env.REACT_APP_VERSION}`,
        description: browser.browser.name ?? '',
        deviceid: deviceId,
        devicemake: browser.os.name ?? '',
        deviceos: browser.os.version ?? '',
        type: 'Desktop',
        userId,
        appname: 'userapp',
    };
};
